import { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import { useLanguage } from "@/context/LanguageContext";

export default function VerifyEmail() {
  const { t } = useLanguage();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading");
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    (async () => {
      if (!token) {
        setState("error");
        return;
      }
      try {
        await api.post("/participant/verify-email", { token });
        setState("success");
      } catch {
        setState("error");
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-[#faf8f5] text-slate-900 flex flex-col" data-testid="verify-email-page">
      <div className="border-b spec-border bg-white p-6">
        <Link to="/" className="flex items-center w-fit">
          <Logo markClass="w-6 h-6 text-blue-600" textClass="text-lg" />
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-sm bg-white border spec-border p-8 rounded-sm shadow-sm text-center">
          {state === "loading" && (
            <div className="text-slate-500 font-mono-spec text-sm" data-testid="verify-loading">
              <Loader2 className="animate-spin mx-auto mb-3" size={28} />
              {t.credit.verifyTitle}
            </div>
          )}
          {state === "success" && (
            <div data-testid="verify-success">
              <CheckCircle2 className="mx-auto text-emerald-600 mb-3" size={40} />
              <h1 className="text-xl font-bold text-slate-950">{t.credit.verifySuccess}</h1>
              <p className="text-sm text-slate-600 mt-2">{t.credit.verifySuccessSub}</p>
              <Link
                to="/konto"
                data-testid="verify-go-wallet"
                className="inline-block mt-6 px-6 py-3 bg-slate-950 hover:bg-slate-800 text-white text-xs font-mono-spec font-bold rounded-full uppercase tracking-wider transition-colors"
              >
                {t.credit.verifyGoWallet}
              </Link>
            </div>
          )}
          {state === "error" && (
            <div data-testid="verify-error">
              <XCircle className="mx-auto text-red-500 mb-3" size={40} />
              <p className="text-sm text-slate-600">{t.credit.verifyError}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
